import React, { useEffect, useState } from "react";
import { DesignField } from "@/components/DesignField";
import { MaidaanVoiceBlock } from "@/components/UIBits";
import { T } from "@/lib/copy";
import { playLine, audioCtl } from "@/lib/audio";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function MeetMaidaan({ lang, beats, onDone, onBack }) {
  const t = T(lang);
  const [i, setI] = useState(0);
  const list = beats && beats.length ? beats : ["…"];

  // Persist "seen" so Welcome + PickChase can render MEET as a timid footer chip on return (B41).
  useEffect(() => { try { localStorage.setItem("so_meet_seen", "1"); } catch (e) {} }, []);

  // V1 lock: auto-play each beat on enter. Global mute toggle in top-bar silences.
  useEffect(() => {
    const line = list[i];
    if (line && line !== "…") {
      const id = setTimeout(() => { playLine({ text: line, persona: "casual", lang }); }, 350);
      return () => clearTimeout(id);
    }
    // eslint-disable-next-line
  }, [i, lang]);
  useEffect(() => () => audioCtl.stop(), []);

  const last = i >= list.length - 1;
  return (
    <div className="so-pad so-pad-top flex flex-col min-h-full" data-testid="maidaan-slideshow">
      <div className="flex items-center justify-between mb-1">
        <button className="back-chip" onClick={onBack} data-testid="maidaan-exit-button" aria-label={t.back}>
          <ChevronLeft size={16} /> {t.back}
        </button>
        <div className="font-mono up" style={{ fontSize: 10, letterSpacing: "0.22em", color: "var(--sm-steel)" }} data-testid="meet-maidaan-kicker">MEET THE MAIDAAN</div>
        <span style={{ width: 56 }} />
      </div>
      <div className="text-center font-reading" style={{ fontSize: 11.5, color: "rgba(244,239,230,0.6)", marginBottom: 12 }} data-testid="meet-maidaan-sub">{t.meetMaidaanSub}</div>

      <div className="flex items-center justify-center gap-2 mb-3">
        {list.map((_, k) => (
          <span key={k} className="dot" style={{ background: k === i ? "var(--sm-blaze)" : "rgba(244,239,230,0.18)", width: k === i ? 22 : 8, transition: "width .3s ease, background .3s ease" }} />
        ))}
      </div>

      <DesignField field="STD" />

      <div className="mt-5">
        <MaidaanVoiceBlock line={list[i]} testid="maidaan-beat" />
      </div>

      <div className="mt-auto pt-6 flex items-center gap-3">
        <button className="btn-secondary px-4 py-3" disabled={i === 0} onClick={() => setI((v) => Math.max(0, v - 1))} data-testid="maidaan-back" style={{ opacity: i === 0 ? 0.4 : 1 }}>
          <ChevronLeft size={18} />
        </button>
        {last ? (
          <button className="btn-primary flex-1 py-4 text-lg" onClick={onBack} data-testid="maidaan-done">{t.readyNow}</button>
        ) : (
          <button className="btn-primary flex-1 py-4 text-lg flex items-center justify-center gap-2" onClick={() => setI((v) => v + 1)} data-testid="maidaan-next">
            {t.next} <ChevronRight size={18} />
          </button>
        )}
      </div>
    </div>
  );
}
